import React from "react";
import StepHeader from "../components/StepHeader";
import OptionCard from "../components/OptionCard";
import OptionGroup from "../components/OptionGroup";
import InfoNote from "../components/InfoNote";
import ContinueButton from "../components/ContinueButton";
import { ACCOUNT_TYPES } from "../content";

/** I-02 / C-01 — Individual or Corporate. The rest of the form follows this choice. */
function AccountTypeStep({ value, onChange, onContinue, onBack, onClose, busy, step, totalSteps }) {
  const selected = ACCOUNT_TYPES.find((type) => type.value === value);

  return (
    <>
      <StepHeader title="Account type" onBack={onBack} onClose={onClose} step={step} totalSteps={totalSteps} />

      <div className="kv-body">
        <h2 className="kv-title">Select your account type</h2>
        <p className="kv-lead">Choose who will own and operate this AGCX account.</p>

        <OptionGroup label="Account type">
          {ACCOUNT_TYPES.map((type) => (
            <OptionCard
              key={type.value}
              icon={type.icon}
              title={type.title}
              subtitle={type.subtitle}
              selected={value === type.value}
              onSelect={() => onChange(type.value)}
              disabled={busy}
            />
          ))}
        </OptionGroup>

        <InfoNote>{selected ? selected.note : ACCOUNT_TYPES[0].note}</InfoNote>
      </div>

      <ContinueButton onClick={onContinue} disabled={!value} busy={busy} />
    </>
  );
}

export default AccountTypeStep;
